import { ICard } from '@monofront/types';
import { capitalizeFirstLetter } from './string';

export const formatCard = (card: ICard) => {
  // Mastercard ····1234
  return `${capitalizeFirstLetter(card.brand)} ····${card.last4}`;
};
